(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["music-player"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const audio = document.getElementById('music-player-audio');
  const player = document.getElementById('music-player-container');
  const disc = document.getElementById('music-disc');
  const tooltip = document.querySelector('.music-tooltip');
  
  if (!audio) return;

  // Set initial volume
  audio.volume = player ? parseFloat(player.dataset.volume) || 0.8 : 0.8;

  // Show tooltip for 2 seconds on load
  if (tooltip) {
    tooltip.style.opacity = '1';
    setTimeout(() => {
      tooltip.style.opacity = '';
    }, 2000);
  }

  // Try polite autoplay first
  if (player && player.dataset.autoplay === "true") {
    audio.play()
      .then(() => {
        if (disc) disc.classList.add('spinning');
        player.classList.add('playing');
      })
      .catch(e => console.log('Autoplay blocked'));
  }

  // Handle play/pause clicks
  if (player) {
    player.addEventListener('click', function(e) {
      e.preventDefault();
      if (audio.paused) {
        audio.play()
          .then(() => {
            if (disc) disc.classList.add('spinning');
            player.classList.add('playing');
          })
          .catch(e => console.log('Playback failed:', e));
      } else {
        audio.pause();
        if (disc) disc.classList.remove('spinning');
        player.classList.remove('playing');
      }
      
      // Briefly show tooltip on click
      if (tooltip) {
        tooltip.style.opacity = '1';
        setTimeout(() => {
          tooltip.style.opacity = '';
        }, 2000);
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
